import { createI18n } from 'vue-i18n'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from './trans'
import en from './en.json'
import az from './az.json'
import ru from './ru.json'
import tr from './tr.json'

// Get saved language from localStorage or use default
const getSavedLocale = () => {
  const saved = localStorage.getItem('app_language')
  if (saved && ['en', 'az', 'ru', 'tr'].includes(saved)) {
    return saved
  }
  return DEFAULT_LANGUAGE
}

export const i18n = createI18n({
  legacy: false, 
  globalInjection: true, 
  locale: getSavedLocale(),
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { en, az, ru, tr },
  silentFallbackWarn: true,
  silentTranslationWarn: true
})

// Function to change language
export const changeLanguage = (locale) => {
  if (['en', 'az', 'ru', 'tr'].includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('app_language', locale)
  }
}
